import { useEffect, useState } from "react";

/**
 * Displays the dynamically generated sitemap at /sitemap.xml without changing the URL.
 * (For best crawler compatibility on custom domains, serve /sitemap.xml at the edge.)
 */
export default function Sitemap() {
  const [xml, setXml] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        const domain = window.location.hostname;
        const baseUrl = import.meta.env.VITE_SUPABASE_URL;
        if (!baseUrl) throw new Error("Missing backend URL");

        const res = await fetch(
          `${baseUrl}/functions/v1/generate-sitemap?domain=${encodeURIComponent(domain)}`,
          { headers: { Accept: "application/xml,text/xml;q=0.9,*/*;q=0.8" } },
        );

        const text = await res.text();
        if (!res.ok) throw new Error(text || `Request failed (${res.status})`);
        setXml(text);
      } catch (e) {
        const message = e instanceof Error ? e.message : "Unknown error";
        setError(message);
      }
    };

    run();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <p className="text-muted-foreground">Error generating sitemap: {error}</p>
      </div>
    );
  }

  if (!xml) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Generating sitemap...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6">
      <pre className="text-xs whitespace-pre-wrap break-words">{xml}</pre>
    </div>
  );
}
